import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { localize } from '../Localizer'
import { formatCurrency } from '../CurrencyFormatter'

const contentStyles = {
  paddingLeft: 14,
  paddingRight: 14,
  fontSize: '0.85rem',
  fontWeight: 400
}

const styles = {
  title: {
    fontSize: '1rem'
  },
  message: {
    ...contentStyles,
    '& small': {
      fontSize: '0.75em',
      fontWeight: 300
    }
  },
  note: {
    ...contentStyles
  }
}

class HCSAPopupTitle extends Component {
  render () {
    return (
      <span className={this.props.classes.title}>
        {localize('pages.SubmitAClaim.Expenses.YourCurrentHealthCareSpendingAccountBalanceHeading')}
      </span>
    )
  }
}

const StyledHCSAPopupTitle = withStyles(styles)(HCSAPopupTitle)

class HCSAPopupMessage extends Component {
  render () {
    const { data = {} } = this.props
    return (
      <p className={this.props.classes.message}>
        {`${localize('pages.SubmitAClaim.Expenses.YourCurrentHealthCareSpendingAccountBalanceText')} ${formatCurrency(data.balance || '')}*.`}
        <br />
        <small>
          {localize('pages.SubmitAClaim.Expenses.Note')}
        </small>
      </p>
    )
  }
}

const StyledHCSAPopupMessage = withStyles(styles)(HCSAPopupMessage)

class HCSAPopupNote extends Component {
  render () {
    return (
      <p className={this.props.classes.note}>
        {localize('pages.SubmitAClaim.Expenses.UnpaidBalancePaidFromYourHealthCareSpendingAccountText')}
      </p>
    )
  }
}

const StyledHCSAPopupNote = withStyles(styles)(HCSAPopupNote)

/* eslint-disable react/display-name */
export default function (data = {}) {
  return {
    title: () => (<StyledHCSAPopupTitle data={data} />),
    message: () => (<StyledHCSAPopupMessage data={data} />),
    note: () => (<StyledHCSAPopupNote data={data} />)
  }
}
/* eslint-enable react/display-name */



// WEBPACK FOOTER //
// ./src/util/ui/HCSAPopupMessage.js